var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1062",
    "data-name": "Group 1062",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.109,
    height: 24,
    viewBox: "0 0 25.109 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1713.176,1160.585h-7.484a2.169,2.169,0,0,0-2.166,2.166v7.484a2.169,2.169,0,0,0,2.166,2.167h7.484a2.169,2.169,0,0,0,2.167-2.167v-7.484A2.169,2.169,0,0,0,1713.176,1160.585Zm-3.742,9.8a3.89,3.89,0,1,1,3.89-3.89A3.894,3.894,0,0,1,1709.434,1170.383Zm4.015-6.976a.92.92,0,1,1,.92-.92A.921.921,0,0,1,1713.449,1163.407Z",
    transform: "translate(-1696.879 -1154.462)",
    fill: "#3b3947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1712.189,1167a2.246,2.246,0,1,0,2.246,2.246A2.249,2.249,0,0,0,1712.189,1167Z",
    transform: "translate(-1699.634 -1157.216)",
    fill: "#3b3947"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1704.434,1148.879a12.012,12.012,0,1,0,12.555,12A12.287,12.287,0,0,0,1704.434,1148.879Zm7.552,15.609a3.733,3.733,0,0,1-3.81,3.642h-7.484a3.733,3.733,0,0,1-3.81-3.642v-7.153a3.733,3.733,0,0,1,3.81-3.641h7.484a3.733,3.733,0,0,1,3.81,3.641Z",
    transform: "translate(-1691.879 -1148.879)",
    fill: "#3b3947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e1a0466b.svg";
export { ForwardRef as ReactComponent };